import styled from 'styled-components';

const ConfirmWrapper = styled.div`
  .confirm-section {
    max-width: 500px;
    padding: 0.5em 0;
    border-radius: 4px;
    background-color: ${p => p.theme.color.background};
    margin: 1em auto;
    box-sizing: border-box;
  }
  p {
    margin: .2em 0;
  }
  .label {
    font-size: .9em;
    color: ${p => p.theme.color.label};    
  }
  .caption {
    font-size: 1.1em;
    padding: 0 1em;
  }
  .row {
    padding: .5em 1em;
    &.half {
      display: flex;      
    }
    .type {
      &:after{
        content: ', '
      };
      &:last-of-type { 
        &:after{
          display: none
        };
      }
    }
  }
  .half-row {
    width: 50%;
    padding-right: 1em;
    box-sizing: border-box;
  }
  .doctor {
    .label {
      margin: -.3em 0 .8em;
    }
  }
  .info-block {
    border-bottom: 1px solid ${p => p.theme.color.border};
    &:last-child {
      border-bottom: none;
    }
  }
  .campus-block-container {
    padding-bottom: 0;
    padding-top: 0;
  }
`;

export default {
  ConfirmWrapper
};